import { i18n } from 'next-i18next';
import { useMemo } from 'react';

import useGetSupportedLocales from '@/hooks/api/me/useGetSupportedLocales';
import useLocale from '@/hooks/useLocale';
import useMedia from '@/hooks/useMedia';

import classNames from '../../helpers/classNames';
import Select from '../Select';
import styles from './LanguageSelect.module.scss';

interface LanguageSelectProps {
  className?: string;
  isAuthenticatedPath?: boolean
}

export default function LanguageSelect(props: LanguageSelectProps) {
  const { className, isAuthenticatedPath = true } = props;
  const { isTablet } = useMedia();
  const { setLanguage } = useLocale();
  const currentLanguage = i18n?.language;
  const { data: supportedLocales } = useGetSupportedLocales(isAuthenticatedPath);

  const options = useMemo(() => {
    return supportedLocales.map((languageTag) => ({
      label: languageTag.toUpperCase(),
      value: languageTag.toLowerCase(),
    }));
  }, [supportedLocales]);

  if (isTablet) {
    return (
      <select
        className={classNames([styles.mobileSelect, className])}
        value={currentLanguage}
        onChange={(event) => void setLanguage(event.target.value)}
      >
        {options.map(({ label, value }, index) => (
          <option key={index} value={value}>
            {label}
          </option>
        ))}
      </select>
    );
  }

  return (
    <Select
      name="language-selector"
      options={options}
      selectButtonVariant="tertiary"
      placeholder=""
      selected={currentLanguage}
      className={classNames([styles.container, className])}
      onSelect={(val) => void setLanguage(val)}
    />
  );
}
